import { CancelButton } from "../../UtilitiesComponents/CancelButton";
import { SaveButton } from "../../UtilitiesComponents/SaveButton";
import { FormProvider, useForm } from "react-hook-form";
import { ChangeStageComment, Deal } from "../../../types/pipeline";
import { Dispatch, ReactNode, SetStateAction, useEffect, useMemo, useState } from "react";
import { ErrorMessage } from "../../UtilitiesComponents/ErrorMessage";
import { CircularProgress } from "@mui/joy";
import { ChangeDealStageFormContainer } from "../ChangeDealStageForms/ChangeDealStageFormContainer";
import { ConfirmDealForm } from "../ChangeDealStageForms/ConfirmDealForm";
import { DefaultStageForm } from "../ChangeDealStageForms/DefaultStageForm";
import { RegisterVisitaForm } from "../ChangeDealStageForms/RegisterVisitaForm";
import { DealInformation } from "../ChangeDealStageForms/DealInformation/DealInformation";
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

interface Props {
    updateStage: (data: ChangeStageComment) => Promise<void>;
    setShowModal: Dispatch<SetStateAction<boolean>>;
    setErrorMessage: Dispatch<SetStateAction<string | null>>;
    currentStageName: string | undefined;
    newStageName: string | null;
    currentFechaVisita: string;
    errorMessage: null | string;
    isLoading: boolean;
    nombreProspectador: string;
    dealId: number;
    empresaId: number;
    estadoEmpresa: string;
}

export type ValidFormCompnentes = 
    "Campañas realizadas" |
    "Campañas confirmadas" |
    "Empresas" |
    "RegisterVisita" |
    "Campañas en espera de confirmacion" |
    "Empresas contactadas";

export function AddCommnetChangeStage({ 
    updateStage,
    currentStageName,
    newStageName,
    setShowModal,
    errorMessage,
    isLoading,
    setErrorMessage,
    currentFechaVisita,
    nombreProspectador,
    dealId,
    empresaId,
    estadoEmpresa,
}: Props) {
    const resetErrorMessage = () => setErrorMessage(null);

    const [currentForm, setCurrentForm] = useState<ValidFormCompnentes>(newStageName as ValidFormCompnentes ?? "Empresas");
    const [formComponent, setFormComponent] = useState<ReactNode>();

    const fechaVisita = currentFechaVisita.split("T")[0];

    const methods = useForm<ChangeStageComment>({
        defaultValues: {
            fechaVisita: currentFechaVisita.length > 0 
                ? currentFechaVisita
                : undefined,
            visitaInfo: {
                fecha: fechaVisita,
                horaInicio: currentFechaVisita.split("T")[1],
                nombreProspectador: nombreProspectador,
                tipoVisitaId: 0,
                turnoId: 0,
                intenciones: [],
            },
            visitas: []
        }
    });

    const { handleSubmit } = methods;

    const submitComment = handleSubmit(async (data: ChangeStageComment) => {
        resetErrorMessage();
        await updateStage(data);
    });

    const displayFechaVisitaInput = 
        estadoEmpresa != "Activa" &&
        currentStageName == "Empresas" && 
        currentFechaVisita.length == 0;
    
    const deal = useMemo(() => {
        const value = {} as Deal;
        value.empresaId = empresaId;
        value.id = dealId;
        return value;
    }, []);{} 

    const stageComponent: Record<ValidFormCompnentes, ReactNode> = useMemo(() => {
        return {
            "Empresas": <DefaultStageForm 
                            displayFechaVisitaInput={displayFechaVisitaInput}/>,
            "Empresas contactadas": <DefaultStageForm />,
            "Campañas confirmadas": <ConfirmDealForm 
                                        setCurrentForm={setCurrentForm} />,
            "RegisterVisita": <RegisterVisitaForm 
                                setCurrentComponent={setCurrentForm} />,
            "Campañas en espera de confirmacion": <DefaultStageForm />,
            "Campañas realizadas": <DealInformation 
                                        deal={deal} />,
        };
    }, [dealId, nombreProspectador, currentFechaVisita, displayFechaVisitaInput]);

    useEffect(() => {
        const component = stageComponent[currentForm];
        setFormComponent(component);
    }, [currentForm]);

    if(currentForm == "Campañas realizadas")
        return(
        <ChangeDealStageFormContainer
            largeWidht
            setShowModal={setShowModal}>
            {formComponent}
        </ChangeDealStageFormContainer>
    )

    return (
        <ChangeDealStageFormContainer setShowModal={setShowModal}>
            <div className="h-full p-3">
                <FormProvider {...methods}>

                    <form onSubmit={submitComment} autoComplete="off">
                        <p className="text-xl font-semibold">Cambio de etapa</p>

                        <div className="flex gap-x-2 mb-3">
                            <p className="text-sm font-semibold">{currentStageName}</p>
                            <ArrowForwardRoundedIcon sx={{ height: 20, width: 20 }}/>
                            <p className="text-sm font-semibold">{newStageName}</p>
                        </div>

                        <div className="overflow-auto">
                            {formComponent}
                        </div>

                        {errorMessage && (
                            <div className="my-2">
                                <ErrorMessage 
                                customMessage>
                                    <p className="text-sm">{errorMessage}</p>
                                </ErrorMessage>
                            </div>
                        )}

                        {currentForm != "RegisterVisita" && (
                        <div className="flex gap-x-2 justify-end pb-4">
                            {isLoading
                            ? 
                            <div className="w-[105px] h-[27px] flex items-center justify-center">
                                <CircularProgress sx={{
                                    "--CircularProgress-progressThickness": "4px",
                                    "--CircularProgress-trackThickness": "4px",
                                    "--CircularProgress-size": "25px"
                                }}/>
                            </div>
                            : <SaveButton 
                                text="Confirmar cambio"
                                type="submit"/>
                            }
                            <CancelButton
                                onClick={()=> {
                                    setShowModal(false);
                                    resetErrorMessage();
                                }}/>
                        </div>
                        )}
                    </form>

                </FormProvider>
            </div>
        </ChangeDealStageFormContainer>
    );
}